import logoof from "../../assets/logoof.png";
import logofs from "../../assets/logofs.png";
import main from "../../assets/main-bg.png";

function MainBlock() {
    return ( 
        <>
            <div className="container main-block">
                <div className="row">

                    <div className="col-12 col-md-12 col-lg-5 main-left-block">
                        <h1 className="main-heading">We Build Outstanding <img src={logoof} alt="onlyfans" className="onlyfans" /><span className="on-color"> Careers</span></h1>
                        <p  className="main-text">
                        Welcome to OnlyGlance Agency, where human expertise and advanced AI technology come together. We're not just a social media management agency; we're setting new standards in how OnlyFans creators grow their accounts. Our mission is to empower creators and become the best in the industry.
                        </p>
                        <a href="#apply-form">
                            <button className="main-button">
                                    Apply                            
                            </button>
                        </a>
                    </div>

                    <div className="col-12 col-md-12 col-lg-7">
                        <div className="main-image-container">
                          <img 
                            src={main} 
                            alt="background" 
                            />
                        </div>
                    </div>

                </div>
            </div>
        </>
     );
}

export default MainBlock;